import React, { Dispatch, SetStateAction } from 'react';
import { Image } from '../../../components/image/Image';
import { ScriptService } from '../../../controllers/ScriptService';
import { getImageByPath } from '../../../queries/ats/common';
import { useRootMenu } from '../../../queries/ats/layout/queries';
import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import { MenuLink } from './menu-link';
import './style.scss';

interface SideMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  openSideMenu: boolean;
  setOpenSideMenu: Dispatch<SetStateAction<boolean>>;
  className?: string;
}

export default function SideMenu({ openSideMenu, setOpenSideMenu, className, ...rest }: SideMenuProps) {
  const { data: menu } = useRootMenu();
  const stickySideContainerClass = 'sticky-side-container sticky' + (ScriptService.onPhone() ? ' phone' : '');

  if (!menu || !openSideMenu) {
    return null;
  }

  return (
    <div className={classes(stickySideContainerClass, className)} {...rest}>
      <nav>
        {menu?.map((item) => {
          return <SideLink key={item.slug} item={item} onClick={() => setOpenSideMenu(!openSideMenu)} />;
        })}
      </nav>
    </div>
  );
}

interface SideLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  item: Layout.SectionItem;
}

function SideLink({ item, ...rest }: SideLinkProps) {
  const slug = item.isRoot ? '' : item.slug;
  const image = getImageByPath(item.image, 'square');

  return (
    <MenuLink type={item.type} slug={slug} {...rest}>
      {image ? <Image src={image} alt={item.name} /> : <span className="aib-icon">{item.icon}</span>}
      <span>{item.name}</span>
    </MenuLink>
  );
}
